// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AtlassianIcon = createSvgIcon(
  <svg xmlSpace="preserve" fill="currentColor" viewBox="0 0 67 67">
    <linearGradient
      id="atlassian_svga"
      x1={28.95}
      x2={11.82}
      y1={-1.87}
      y2={-31.55}
      gradientTransform="matrix(1 0 0 -1 0 34.04)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#0052CC" />
      <stop offset={0.92} stopColor="#2684FF" />
    </linearGradient>
    <path
      fill="url(#atlassian_svga)"
      d="M20 30.9c-.6-.8-1.8-1-2.6-.4-.2.2-.4.4-.6.7L.6 63.7c-.5 1-.1 2.1.9 2.6.3.1.6.2.9.2H25c.7 0 1.4-.4 1.7-1.1 4.8-10 1.9-25.3-6.7-34.5"
    />
    <path
      fill="#2684FF"
      d="M31.9 1.4a42.9 42.9 0 0 0-2.5 42.3l10.9 21.7c.3.7 1 1.1 1.7 1.1h22.6c1.1-.1 1.9-1.1 1.8-2.2 0-.2-.1-.4-.2-.6l-31-62.3C34.8.5 33.7.1 32.8.5q-.6.45-.9.9"
    />
  </svg>,
  "Atlassian",
);
export default AtlassianIcon;
